module.exports = __webpack_public_path__ + "img/wancheng.b4039083.png";